import React from "react"

const CyanWave = () => {
  return (
    <div className="cyan-wave__svg">
      <svg className="wave_svg"
        width="2160"
        height="263"
        viewBox="0 0 2160 263"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Wave-one"
          fillRule="evenodd"
          clipPath="evenodd"
          d="M2160 262.5H0V0C360 80 720 120 1080 120C1440 120 1800 80 2160 0V262.5Z"
          fill="#F8FBFF"
        />
      </svg>
    </div>
  )
}
export default CyanWave
